import styled from 'styled-components'

export const StyledDiv = styled.div`
  position: fixed;
  z-index: 1001;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`
